import getters from "./getters";
import actions from "@/store/modules/floatMenu/actions";
import mutations from "@/store/modules/floatMenu/mutations";
const state = {
  showFloatMenu: false,
  manageSpace: false,
  openProfile: false,
  openProfileSocial: false,
  openEmojiSelector: false,
  openConsoleMessage: false,
  openHelpBot: false,
  openReasonSelector: false,
  showNextMaintennace: false,
  timeNextMaintennace: "",
  openConsoleMessageMultiSpace: false,
  openCalendarModal: false,
  openChageSpaceSelector: false,
};
export type State = typeof state;

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
